import { BookingUserProfileModel } from 'src/services/booking';

export function selectedDoctorIsDisplayOnly(doctorId: string | number, doctors: BookingUserProfileModel[]) {
    return doctors.find((d) => d.userId === doctorId)?.displayProfileNoOnlineBooking;
}

export function isDoctorVirtualGp(doctor: BookingUserProfileModel): boolean {
    if (!doctor) {
        return false;
    }
    return doctor.automedDisplayName.trim().toLocaleUpperCase() === 'EXPRESS TELEHEALTH';
}
